import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuModel } from '../../models/menu.model';

@Component({
  selector: 'app-public-navigation',
  templateUrl: './public-navigation.component.html',
  styleUrls: ['./public-navigation.component.css']
})
export class PublicNavigationComponent {
  @Input() menuItems: MenuModel[] = [];
  @Input() isAuthenticate = false;
  @Input() nameMenu = '';
  @Input() showManagerSwitch = false;
  @Input() moodleUrl = '';
  @Input() themeClass = '';
  @Input() navClass = 'topbar-public';
  @Input() collapseId = 'navbarNavDropdown';

  @Output() geoBosquesClick = new EventEmitter<void>();
  @Output() loginClick = new EventEmitter<void>();
  @Output() logoutClick = new EventEmitter<void>();
  @Output() managerClick = new EventEmitter<void>();

  onGeoBosquesClick(): void {
    this.geoBosquesClick.emit();
  }

  onLoginClick(): void {
    this.loginClick.emit();
  }

  onLogoutClick(): void {
    this.logoutClick.emit();
  }

  onManagerClick(): void {
    this.managerClick.emit();
  }
}
